import type { ReactNode } from "react";
import { Navigate, NavLink } from "react-router-dom";
import { useAdminAuth } from "@/lib/admin-auth";
import { api } from "@/lib/api";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/products", label: "Products", end: false },
  { to: "/admin/categories", label: "Categories", end: false },
  { to: "/admin/orders", label: "Orders", end: false },
];

export function AdminLayout({ children }: { children: ReactNode }) {
  const { user, loading, refresh } = useAdminAuth();

  if (loading) return <div className="flex min-h-screen items-center justify-center bg-cream" />;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen bg-cream">
      <header className="flex items-center justify-between border-b border-stone-300 bg-white px-6 py-4">
        <span className="font-display text-lg font-semibold text-ink">Allthingsnew · Admin</span>
        <div className="flex items-center gap-4">
          <span className="text-xs text-stone-500">{user.email}</span>
          <button
            type="button"
            className="text-xs font-semibold text-wine"
            onClick={async () => {
              await api.auth.logout();
              await refresh();
            }}
          >
            Sign out
          </button>
        </div>
      </header>

      <nav className="flex gap-1 border-b border-stone-300 bg-white px-6">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                "border-b-2 px-3 py-3 text-sm font-semibold",
                isActive ? "border-ink text-ink" : "border-transparent text-stone-500",
              ].join(" ")
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <main className="mx-auto max-w-5xl px-6 py-8">{children}</main>
    </div>
  );
}
